module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-cyrillic607.46a5b9d.woff2";